import styled from "styled-components"
import media from "styled-media-query"

const ContentWrapper = styled.div`
  display: block;
  width: 100%;
  padding: 48px;

  ${media.lessThan("large")`
        padding: 36px;
    `}

  ${media.lessThan("small")`
        padding: 18px;
    `}
`

export default ContentWrapper
